export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./game-providers.vue?vue&type=template&id=f9b7dd16"


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/settings/game-providers.vue?vue&type=template&id=f9b7dd16
// module id = rrJt
// module chunks = 0